import React from "react";
import { Label } from "./InputContainer";
import { styled } from "styled-components";
import fipayFonts from "../../theme/index";

export interface TextAreaProps {
  label: string;
  height?: string;
  disabled?: boolean;
  error?: string | false | undefined;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  name: string;
}
const TextArea: React.FC<TextAreaProps> = ({
  label,
  height,
  disabled,
  error,
  onChange,
  name,
}) => {
  return (
    <Label>
      <span>{label}</span>
      <TextAreaStyle
        name={name}
        $height={height}
        $error={error}
        disabled={disabled}
        $disabled={disabled}
        onChange={onChange}
      ></TextAreaStyle>
    </Label>
  );
};

export const TextAreaStyle = styled.textarea<{
  $height?: string;
  $error?: string | false | undefined;
  $disabled?: boolean;
}>`
  height: ${({ $height }) => $height || "92px"};
  resize: none;
  padding: 8px;
  border: 1px solid ${({ $error }) => ($error ? "#B00020" : "#f0f2f4")};
  border-radius: 15px;
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  font-size: ${fipayFonts.fipayFonts.fontSize.body2};
  background: ${({ $error, $disabled }) =>
    $error ? "#FED8D880" : $disabled ? "#F7F7F7" : "transparent"};
  margin-bottom: 2rem;
  &::placeholder {
    color: #b9b8b8;
    font-size: ${fipayFonts.fipayFonts.fontSize.body2};
    opacity: 0.6;
    position: absolute;
    left: 0.2rem;
  }

  &:focus {
    border: 1px solid #3f4188;
    outline: none;
    background-color: #e9eaf9;
  }
`;
export default TextArea;
